// Copyright (c) Microgreen Manager LLC. All rights reserved. Proprietary and confidential. Unauthorized copying is strictly prohibited.
import type Decimal from 'decimal.js';
// biome-ignore lint/style/useImportType: <explanation>
import * as React from 'react';
import { TextField } from '../../lib/base';
import { Table } from '../common/table';
import type { ColumnType } from '../common/table/Table';

export interface LostTraysOption {
  readonly traysAvailable: Decimal;
  readonly orderInfo: {
    readonly orderId: number;
    readonly customer: string;
  };
}

interface Props {
  readonly options: readonly LostTraysOption[];
  readonly pullFromMap: Map<number, string>;
  readonly validationMap: Map<number, string>;
  readonly allTraysAvailable: number;
  readonly onChangePullFrom: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>, orderId: number) => void;
  readonly onBlurPullFrom: (e: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement>, orderId: number) => void;
  readonly disabled: boolean;
}

export default function WhichTraysToPullTable({
  options,
  pullFromMap,
  validationMap,
  onChangePullFrom,
  onBlurPullFrom,
  disabled,
  allTraysAvailable,
}: Props) {
  const columns: ColumnType[] = [
    {
      name: 'Order',
      values: options.map((option) => option.orderInfo.customer),
    },
    {
      name: 'Trays Assigned',
      smallName: 'Assigned',
      values: options.map((option) => option.traysAvailable.toFixed(2)),
    },
    {
      name: 'Trays to Deduct',
      values: options.map((option) => (
        <TextField
          key={option.orderInfo.orderId}
          id={`trays-to-deduct-${option.orderInfo.customer}`}
          // label="Trays"
          value={pullFromMap.get(option.orderInfo.orderId) ?? '0'}
          inputMode="decimal"
          type="number"
          numberMin={0}
          numberMax={Math.min(option.traysAvailable.toNumber(), allTraysAvailable)}
          onChange={(e) => onChangePullFrom(e, option.orderInfo.orderId)}
          onBlur={(e) => onBlurPullFrom(e, option.orderInfo.orderId)}
          disabled={disabled}
          error={
            validationMap.get(option.orderInfo.orderId) !== undefined &&
            validationMap.get(option.orderInfo.orderId) !== ''
          }
          numberStep={0.01}
          // subtext={validationMap.get(option.orderInfo.orderId)}
          // hasSubtext
        />
      )),
    },
  ];

  return <Table columns={columns} />;
}
